<template>
  <div class="videos-page">
    <div class="block-container">
      <aside class="banner-horizontal">
        <div class="ad-slot-header ad-slot" id="ad-slot-header"></div>
      </aside>
    </div>
    <div class="block-container" v-if="hasVideos || activeRequest">
      <div class="board">
        <div class="page page-resultados padding-lr">
          <div class="search-term">{{ title }}</div>
        </div>
        <section class="section padding-lr">
          <div class="videos-page__grid videos-page__grid--vertical" v-if="verticalVideos.length > 0">
            <article-video
                v-if="verticalVideo(0)"
                :video="verticalVideo(0)"
                :aspect-ratio="aspectRatioFor(verticalVideo(0))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(1)"
                :video="verticalVideo(1)"
                :aspect-ratio="aspectRatioFor(verticalVideo(1))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(2)"
                :video="verticalVideo(2)"
                :aspect-ratio="aspectRatioFor(verticalVideo(2))"
                :class="cssClass"
                :title-on-video="true"
            />
            <aside class="banner-container">
              <div class="banner-300x250">
                <div class="ad-slot-box ad-slot" id="ad-slot-box1"></div>
              </div>
            </aside>
            <article-video
                v-if="verticalVideo(3)"
                :video="verticalVideo(3)"
                :aspect-ratio="aspectRatioFor(verticalVideo(3))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(4)"
                :video="verticalVideo(4)"
                :aspect-ratio="aspectRatioFor(verticalVideo(4))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(5)"
                :video="verticalVideo(5)"
                :aspect-ratio="aspectRatioFor(verticalVideo(5))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(6)"
                :video="verticalVideo(6)"
                :aspect-ratio="aspectRatioFor(verticalVideo(6))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(7)"
                :video="verticalVideo(7)"
                :aspect-ratio="aspectRatioFor(verticalVideo(7))"
                :class="cssClass"
                :title-on-video="true"
            />
            <article-video
                v-if="verticalVideo(8)"
                :video="verticalVideo(8)"
                :aspect-ratio="aspectRatioFor(verticalVideo(8))"
                :class="cssClass"
                :title-on-video="true"
            />
            <aside class="banner-container">
              <div class="banner-300x250">
                <div class="ad-slot-box ad-slot" id="ad-slot-box2"></div>
              </div>
            </aside>
            <article-video
                v-if="verticalVideo(9)"
                :video="verticalVideo(9)"
                :aspect-ratio="aspectRatioFor(verticalVideo(9))"
                :class="cssClass"
                :title-on-video="true"
            />
            <template v-if="verticalVideos.length >= 13">
              <article-video
                  v-if="verticalVideo(10)"
                  :video="verticalVideo(10)"
                  :aspect-ratio="aspectRatioFor(verticalVideo(10))"
                  :class="cssClass"
                  :title-on-video="true"
              />
              <article-video
                  v-if="verticalVideo(11)"
                  :video="verticalVideo(11)"
                  :aspect-ratio="aspectRatioFor(verticalVideo(11))"
                  :class="cssClass"
                  :title-on-video="true"
              />
              <article-video
                  v-if="verticalVideo(12)"
                  :video="verticalVideo(12)"
                  :aspect-ratio="aspectRatioFor(verticalVideo(12))"
                  :class="cssClass"
                  :title-on-video="true"
              />
              <article-video
                  v-if="verticalVideo(13)"
                  :video="verticalVideo(13)"
                  :aspect-ratio="aspectRatioFor(verticalVideo(13))"
                  :class="cssClass"
                  :title-on-video="true"
              />
            </template>
          </div>
          <aside class="banner-horizontal" v-if="verticalVideos.length > 0">
            <div class="ad-slot-horizontal ad-slot" id="ad-slot-horizontal1"></div>
          </aside>
          <div class="videos-page__grid videos-page__grid--horizontal" v-if="horizontalVideos.length > 0">
            <template v-if="horizontalVideos.length >= 3">
              <article-video
                  v-if="horizontalVideo(0)"
                  :video="horizontalVideo(0)"
                  :aspect-ratio="aspectRatioFor(horizontalVideo(0))"
                  :class="cssClass"
              />
              <aside class="banner-container">
                <div class="banner-300x250">
                  <div class="ad-slot-box ad-slot" id="ad-slot-box3"></div>
                </div>
              </aside>
              <article-video
                  v-if="horizontalVideo(1)"
                  :video="horizontalVideo(1)"
                  :aspect-ratio="aspectRatioFor(horizontalVideo(1))"
                  :class="cssClass"
              />
              <article-video
                  v-if="horizontalVideo(2)"
                  :video="horizontalVideo(2)"
                  :aspect-ratio="aspectRatioFor(horizontalVideo(2))"
                  :class="cssClass"
              />
            </template>
            <template v-if="horizontalVideos.length >= 7">
              <article-video v-if="horizontalVideo(3)" :video="horizontalVideo(3)" :aspect-ratio="aspectRatioFor(horizontalVideo(3))" :class="cssClass" />
              <article-video v-if="horizontalVideo(4)" :video="horizontalVideo(4)" :aspect-ratio="aspectRatioFor(horizontalVideo(4))" :class="cssClass" />
              <article-video v-if="horizontalVideo(5)" :video="horizontalVideo(5)" :aspect-ratio="aspectRatioFor(horizontalVideo(5))" :class="cssClass" />
              <article-video v-if="horizontalVideo(6)" :video="horizontalVideo(6)" :aspect-ratio="aspectRatioFor(horizontalVideo(6))" :class="cssClass" />
            </template>
            <template v-if="horizontalVideos.length >= 11">
              <article-video v-if="horizontalVideo(7)" :video="horizontalVideo(7)" :aspect-ratio="aspectRatioFor(horizontalVideo(7))" :class="cssClass" />
              <article-video v-if="horizontalVideo(8)" :video="horizontalVideo(8)" :aspect-ratio="aspectRatioFor(horizontalVideo(8))" :class="cssClass" />
              <article-video v-if="horizontalVideo(9)" :video="horizontalVideo(9)" :aspect-ratio="aspectRatioFor(horizontalVideo(9))" :class="cssClass" />

              <aside class="banner-container">
                <div class="banner-300x250">
                  <div class="ad-slot-box ad-slot" id="ad-slot-box4"></div>
                </div>
              </aside>
              <article-video v-if="horizontalVideo(10)" :video="horizontalVideo(10)" :aspect-ratio="aspectRatioFor(horizontalVideo(10))" :class="cssClass" />
            </template>
          </div>
          <aside class="banner-horizontal" v-if="horizontalVideos.length > 0">
            <div class="ad-slot-horizontal ad-slot" id="ad-slot-horizontal2"></div>
          </aside>
          <div class="videos-loading" v-if="activeRequest">
            <preload />
          </div>
        </section>
      </div>
    </div>
    <div class="block-container" v-if="(true === error || !hasVideos) && !activeRequest">
      <div class="board-404">
        <h2>No se encontraron más videos</h2>
        <p>Te invitamos a seguir navegando <a href="/">iProUP</a>.</p>
      </div>
    </div>

  </div>
</template>


<script>
import _Page from '@core/vuejs/templates/mixins/_Page'
import {defineAsyncComponent} from "vue";
import Lazyload from '@core/assets/js/modules/lazyload'

export default {
  name: "VideosPage",
  mixins: [_Page],
  components: {
    'article-video': defineAsyncComponent(() => import(/* webpackChunkName: "article-video" */'@app/templates/vuejs/components/articles/ArticleVideoLanding')),
    'preload': defineAsyncComponent(() => import(/* webpackChunkName: "preload" */'@app/templates/vuejs/components/_partials/Preload'))
  },
  data: function() {
    return {
      title: 'Videos',
      limit: 30,
      activeRequest: false,
      error: false,
    };
  },
  beforeMount() {
    if (typeof window !== 'undefined' && window._page && !this.hasVideos) {
      this.$store.commit('videos/setVideos', window._page.content)
    }
  },
  computed: {
    videos: function() {
      return this.$store.getters['videos/videos'] || [];
    },
    hasVideos: function () { return this.$store.getters['videos/hasVideos'] },
    cssClass: function() { return this.activeRequest ? 'active-request' : ''},
    verticalVideos: function() {
      return this.filterVideos(true);
    },
    horizontalVideos: function() {
      return this.filterVideos(false);
    }
  },
  mounted() {
    if (!this.hasVideos) {
      this.activeRequest = true;
      this.error = false;

      this.$store.dispatch('videos/fetchHistory', { limit: this.limit })
          .then(() => {
            if (typeof window !== 'undefined') {
              setTimeout(() => Lazyload.start(), 500);
            }
          })
          .catch(() => {
            this.error = true;
          })
          .finally(() => {
            this.activeRequest = false;
          });
    } else if (typeof window !== 'undefined') {
      setTimeout(() => Lazyload.start(), 500);
    }
  },
  methods: {
    verticalVideo: function(index) {
      return (Array.isArray(this.verticalVideos) && this.verticalVideos[index]) ? this.verticalVideos[index] : false;
    },

    horizontalVideo: function(index) {
      return (Array.isArray(this.horizontalVideos) && this.horizontalVideos[index]) ? this.horizontalVideos[index] : false;
    },

    aspectRatioFor: function(video) {
      return (video?.info?.aspectRatio ?? '16:9').replace(':', ' / ');
    },

    isVertical(video) {
      const w = Number(video?.info?.width);
      const h = Number(video?.info?.height);

      if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
        return h > w; // vertical
      }

      return false; // default horizontal
    },

    filterVideos: function(vertical = true) {
      const videos = Array.isArray(this.videos) ? [...this.videos] : [];

      const filtered = videos.filter(video => {
        return vertical ? this.isVertical(video) : !this.isVertical(video);
      });

      return filtered;
    }
  }
}
</script>
